"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFieldsfor = void 0;
const IssueMetaModel_1 = __importDefault(require("@opsbase/lib-data-metamodel/metamodels/IssueMetaModel"));
const OpMetaModel_1 = __importDefault(require("@opsbase/lib-data-metamodel/metamodels/OpMetaModel"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const lib_event_1 = __importDefault(require("@opsbase/lib-event"));
function queryFieldsfor(eventType) {
    switch (eventType) {
        case lib_event_1.default.ISSUE_CREATED:
        case lib_event_1.default.ISSUE_MISSED:
        case lib_event_1.default.ISSUE_COMMENT:
        case lib_event_1.default.ISSUE_STATUS_CHANGED:
        case lib_event_1.default.ISSUE_ASSIGNED:
        case lib_event_1.default.ISSUE_CLOSED:
            return IssueMetaModel_1.default.filterables.filter(f => [QueryFieldKey_1.default.KEYWORD].every(k => k !== f.key));
        case lib_event_1.default.OP_COMPLETE:
            return OpMetaModel_1.default.filterables
                .filter(f => [QueryFieldKey_1.default.KEYWORD].every(k => k !== f.key))
                .concat(QueryFieldRegistry_1.default[QueryFieldKey_1.default.OP_QUESTION]);
        case lib_event_1.default.OP_MISSED:
        case lib_event_1.default.OP_LATE:
        case lib_event_1.default.OP_DUE:
            return OpMetaModel_1.default.filterables.filter(f => [
                QueryFieldKey_1.default.KEYWORD,
                QueryFieldKey_1.default.OP_SCORE,
                QueryFieldKey_1.default.OP_GRADE,
                QueryFieldKey_1.default.OP_PASSSTATUS,
                QueryFieldKey_1.default.OP_HASISSUES,
            ].every(k => k !== f.key));
        case lib_event_1.default.SENSOR_READING:
            return [
                // QueryFieldRegistry[QueryFieldKey.ASSET],
                QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET_SENSOR_TEMPERATURE],
                QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET_SENSOR_HUMIDITY],
                QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET_SENSOR_WATER_PRESENT],
                QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET_SENSOR_OBJECT_PRESENT],
            ];
        case lib_event_1.default.SCHEDULE:
            return [QueryFieldRegistry_1.default[QueryFieldKey_1.default.ASSET_LASTSERVICEDATE]];
        default:
            return [];
    }
}
exports.queryFieldsfor = queryFieldsfor;
